import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxlcc_flightselector';
export const route = 'cnxlcc_flightselector/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxlcc_flightselector" */
/* webpackPrefetch: true */
'../components/FlightSelectorLCCPage')));